import { SignInComponentMeQuery$data } from "@src/components/__generated__/SignInComponentMeQuery.graphql";

export interface UserKycBonus {
    amount: string
    currency: string
    playThrough: number
}

export enum UserProp {
  ACTIVE_COIN = 'active_coin',
  SOUND_ENABLED = 'sound_enabled',
  COIN_UNIT = 'unit_',
  BACKGROUND = 'bg',
  CHAT_VISIBLE = 'chat_visible',
  CARD_THEME = 'card_theme',
  CARD_BACK = 'card_back',
  NICKNAME = 'chat_nickname',
  PRIVATE = 'private',
  FAVOURITES = 'favourites',
  TAB = 'tab',
  HOME_PAGE = 'home_page',
}

export type UserKycState = 'idle' | 'waiting_submission' | 'waiting_confirmation';

export interface UserStat {
    name: string;
    value: number;
    meta: any | null;
}

export interface UserAffiliateStats {
    count: number
    totalCreditSumUsd: number
    creditByCurrency: string
}

export interface UserPreference {
    key: string | null;
    value: string | null;
    valueJson: string | null;
}

export interface UserEliteSeatLevel {
    name: string;
    tierStartUsd: number;
    tierStartLevel: number;
    tierStep: number;
    tierCount: number;
    bonusUsd: number[];
}

export interface UserEliteSeatPendingPayout {
    levelNr: number
    bonusUsd: number
    dateTime: string
}

export interface UserEliteSeat {
    currentLevel: UserEliteSeatLevel | null;
    currentTier: number;
    nextLevel: UserEliteSeatLevel | null;
    tierProgress: number;
    levelProgress: number;
    pendingPayouts: UserEliteSeatPendingPayout[];
    wagerAmountUsd: number;
}

export interface UserProfile {
    name: string | null;
    username: string | null;
}

export interface UserKyc {
    kycState?: UserKycState
    kycSuccessful?: boolean | null;
    pendingKycBonuses?: UserKycBonus[]
}

export interface UserMetadata {
    otpEnabled: boolean | null;
    roles: ReadonlyArray<string> | null;

    featureFlags: string[] | null;

    userStats: UserStat[];
    affiliateStats: UserAffiliateStats;

    preferences: UserPreference[] | null;
    eliteSeat: UserEliteSeat;

    insertedAt: string | null;
    confirmed: boolean | null;
    chatApproval: boolean | null;

    /** @deprecated */
    anonymousHash: string | null;
}

export type User = Partial<UserProfile> & Partial<UserKyc> & Partial<UserMetadata> & {
    uuid: string

    hasProfileImage?: boolean;
    refProps?: any | null;
}

export type UserInformation = { 
  user: User; 
  token: string; 
  origin?: Origin; 
}

export type UserUpdater = (info: null | UserInformation) => null | UserInformation

export interface UserStoreState {
    value: null | UserInformation;
}

export interface UserStoreActions {
    update(info: null | UserInformation | UserUpdater): void;
}

export type UserStore = UserStoreState & UserStoreActions

export type Origin = SignInComponentMeQuery$data['detailedMe']['origin']